import React,{Component,useEffect,useState} from 'react';
import {Link,useHistory} from "react-router-dom";
import {auth,data} from './firebase';
import './css/Annonce.css'
import './css/Int.css';
import ListAltIcon from '@material-ui/icons/ListAlt';
import CameraAltOutlinedIcon from '@material-ui/icons/CameraAltOutlined';
import ForwardIcon from '@material-ui/icons/Forward';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useStateValue } from './StateProvider';
function Annonce() {
    
    const[{user},dispatch]=useStateValue();
    const [usesa,setUs]=useState([]);
    const [id,setid]=useState([]);
    useEffect(()=>{
        get();
        fetchBlogs();
        auth.onAuthStateChanged(authUser=>{
            if(authUser){
                dispatch({
                    type:'SET_USER',
                    user: authUser
                })
                
            }else{
                dispatch({
                    type:'SET_USER',
                    user: null
                })
            }
        })
    },[])
    function get() {
        data.collection("Products").get().then((item)=> {
            const items =item.docs.map((doc)=>doc.data());
            
            setUs(items)
        });
        
        
    }

    const fetchBlogs=async()=>{
        const response=data.collection('Products');
        const dat=await response.get();
        dat.forEach(doc => {
            setid(doc.id)
          });
    }

    var b=[]
    for(var i=0;i<usesa.length;i++){
        if(usesa[i].UID==user.uid){
            b.push(usesa[i])
        }
    }
    console.log(id)
    if(b.length!=0){
        return(
            <div className="body" style={{paddingBottom:"1rem"}}>
                <div className="body">
                <button>
                    <ListAltIcon className="icon"/>
                    <p>Mes annonces</p>
                </button>
                
                <form>
                    <ForwardIcon className="icon"/>
                    <select name="filtersList" class="s">
                        <option value="active">Actives ({b.length})</option>
                        <option value="refused">Rejetées (0)</option>
                        <option value="deactivated">Désactivées (0)</option>
                        <option value="deleted">Supprimées (0)</option>
                        <option value="pending_review">Dans la modération (0)</option>
                        <option value="pending_payment">Paiement en attente (0)</option>
                    </select>
                    <ExpandMoreIcon className="icon i2"/>
                </form>
            </div>    
                    
                <div className="f">
                    
                {b.map((e,index)=>{
                    var link = "/Product/"+e.id
                    return(
                            <a className="BOXa" href={link}>
                                <div className="imgbox">
                                    <img src={e.img}/>
                                    <span></span>
                                    <span>{e.Day} à {e.Time}</span>
                                </div>
                                <div className="txtbox">
                                    <p>{e.prix}</p>
                                    <span>{e.title}</span>
                                </div>
                            </a>
                        
                    )
                })}
                
                </div>
                <div className="tex z">
                    <Link to="/deposer" style={{textDecoration:"none"}}>
                        <button>
                            <p><CameraAltOutlinedIcon className="ico"/>Déposer une autre annonce</p>
                        </button>
                    </Link>
                </div>
            </div>
            
            
        )
    }else{
        return(
            <div className="body">
                <button>
                    <ListAltIcon className="icon"/>
                    <p>Mes annonces</p>
                </button>
                
                <form>
                    <ForwardIcon className="icon"/>
                    <select name="filtersList" class="s">
                        <option value="active">Actives (0)</option>
                        <option value="refused">Rejetées (0)</option>
                        <option value="deactivated">Désactivées (0)</option>
                        <option value="deleted">Supprimées (0)</option>
                        <option value="pending_review">Dans la modération (0)</option>
                        <option value="pending_payment">Paiement en attente (0)</option>
                    </select>
                    <ExpandMoreIcon className="icon i2"/>
                </form>
                <div className="tex">
                    <img src="https://account.avito.ma/phoenix-assets/imgs/account/noResultActivate.png"/>
                    <p>Vous avez quelque chose à vendre?</p>
                    <p>Déposez votre annonce gratuitement sur Avito.ma aujourd'hui</p>
                    <Link to="/deposer" style={{textDecoration:"none"}}>
                        <button>
                            <p><CameraAltOutlinedIcon className="ico"/>Déposer une autre annonce</p>
                        </button>
                    </Link>
                </div>
            </div>
        )
    }
}

export default Annonce